import { render, staticRenderFns } from "./CustomStateEvent.vue?vue&type=template&id=8195de5a&scoped=true&"
import script from "./CustomStateEvent.vue?vue&type=script&lang=js&"
export * from "./CustomStateEvent.vue?vue&type=script&lang=js&"
import style0 from "./CustomStateEvent.vue?vue&type=style&index=0&id=8195de5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8195de5a",
  null
  
)

export default component.exports